var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0572 10.3905C12.5365 10.9112 12.5365 11.7554 13.0572 12.2761L16.781 16L13.0572 19.7239C12.5365 20.2446 12.5365 21.0888 13.0572 21.6095C13.5779 22.1302 14.4221 22.1302 14.9428 21.6095L19.6095 16.9428C20.1302 16.4221 20.1302 15.5779 19.6095 15.0572L14.9428 10.3905C14.4221 9.86983 13.5779 9.86983 13.0572 10.3905Z",
    fill: "#23262F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.97624a62edca57403388641ee63846f8.svg";
export { ForwardRef as ReactComponent };